import { IonButton } from "@ionic/react";

interface Props {
  setGraphAsseDesc: Function;
  title: string;
  unit: string;
  description: string;
  measurementDescription: string;
  measurementsList: (string | { main: string; sub: string[] })[];
  icon: React.ReactNode;
}
const GraphAssessmentDescriptionModal: React.FC<Props> = ({
  setGraphAsseDesc,
  title,
  unit,
  description,
  measurementDescription,
  measurementsList,
  icon,
}) => {
  return (
    <div className="graph-assessment-modal-desc">
      <div className="d-flex justify-content-end">
        <svg
          onClick={() => {
            setGraphAsseDesc(false);
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
            stroke="#D1D1D1"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="text-center mb-32">{icon}</div>
      <h1 className="assesment-modal-info text-center mb-24">
        {title} {unit}
      </h1>
      <div className="description-wrap">
        <h6 className="assesment-modal-desc text-black fw-700 mb-8 mt-0">
          {" "}
          Description
        </h6>
        <h6 className="assesment-modal-desc dark-slate-gray">{description} </h6>
        {(measurementDescription !== "" || measurementsList.length > 0) && (
          <div>
            {!title.toLowerCase().includes("overall") && (
              <div className="assesment-divider"></div>
            )}
            {measurementDescription !== "" &&
              !title.toLowerCase().includes("overall") && (
                <h6 className="assesment-modal-desc text-black fw-600 mt-0 mb-16">
                  {measurementDescription}
                </h6>
              )}
            {measurementDescription !== "" &&
              title.toLowerCase().includes("overall") && (
                <h6 className="assesment-modal-desc dark-slate-gray">
                  {measurementDescription}
                </h6>
              )}

            {measurementsList.length > 0 && (
              <ul className="mb-32">
                {measurementsList.map((item, index) => {
                  // If item is a string, render as simple bullet point
                  if (typeof item === "string") {
                    return (
                      <li className="dark-slate-gray" key={index}>
                        {item}
                      </li>
                    );
                  }
                  // If item is an object with main and sub, render nested bullets
                  return (
                    <li className="dark-slate-gray" key={index}>
                      {item.main}
                      {item.sub && item.sub.length > 0 && (
                        <ul>
                          {item.sub.map((subItem, subIndex) => (
                            <li key={subIndex}>{subItem}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
        <div className="d-flex justify-content-center">
          <IonButton
            placeholder={undefined}
            className="blue-btn w-50"
            onClick={() => {
              setGraphAsseDesc(false);
            }}
          >
            Close
          </IonButton>
        </div>
      </div>
    </div>
  );
};
export default GraphAssessmentDescriptionModal;
